import { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

import './style.scss'
import CONFIG from '../../../config'
import { AuthRoles } from '../../models'
import { Button, Text, Dropdown, Icon } from '../../components/UI'
import logoIcon from '../../assets/img/logo-dash.svg'
import { useAuth, useNotify } from '../../hooks'
import { Menu } from '../../components'
import { HeaderNotify } from './'
import { Lightbox } from '../../components/UI/Lightbox'

type HeaderProps = {
  type?: 'public' | '',
  role?: AuthRoles
}

const Header:FC<HeaderProps> = ({ type = '', role = '' })  => {
  const history = useHistory()
  const userCurrent = useAuth()
  const isLoggedIn = userCurrent.isLoggedIn(role)
  const notify = useNotify(role)
  const [optionsShow, setOptionsShow] = useState<boolean>(false)
  const [notifyShow, setNotifyShow] = useState<boolean>(false)
  const [menuShow, setMenuShow] = useState<boolean>(false)

  const getRedirect = (role: AuthRoles) => {
    if(role === CONFIG.AUTH.ROLES.ADMIN && isLoggedIn) return CONFIG.ROUTES.ADMIN.USERS.HOME
    else if(role === CONFIG.AUTH.ROLES.ADMIN) return CONFIG.ROUTES.ADMIN.HOME
    else if(isLoggedIn) return CONFIG.ROUTES.DASHBOARD.HOME
    else return CONFIG.ROUTES.HOME
  }

  const onUserOptionsToggle = () => {
    setMenuShow(false)
    setNotifyShow(false)
    setOptionsShow(!optionsShow)
  }

  const onLogout = () => {
    userCurrent.logout()
    history.push(role === CONFIG.AUTH.ROLES.ADMIN ? CONFIG.ROUTES.ADMIN.HOME : CONFIG.ROUTES.HOME)
  }

  const onAppointmentShow = () => {
    (window as any).show_chat()
  }

  const onAppointmentContactShow = () => {
    (window as any).show_chat(CONFIG.APPOINTMENT_CONTACT)
  }

  const OpenLightbox = () => {
    const coverLightbox = document.querySelector("#lightbox") as HTMLElement;
    if (coverLightbox) {
      coverLightbox.style.display = "block";
    }
  };

  const onMenuToggle = (event: any) => {
    event.preventDefault()
    setOptionsShow(false)
    setNotifyShow(false)
    setMenuShow(!menuShow)
  }

  const onNotifyToggle = () => {
    setMenuShow(false)
    setOptionsShow(false)
    setNotifyShow(!notifyShow)
  }

  const onNotifyRead = (id: number) => {
    notify.setNotificationRead(id)
  }

  return (
    <header className="header">
      <div className="header_top" />
      <div className="lg:container">
        <div className="lg:d-flex lg:flex-wrap lg:align-items-center">
          <div className="container header_container">
            <div className="header_logo-dash">
              <Link to={getRedirect(role)}>
                <img src={logoIcon} alt="Indisa" width="130" height="130" className="header_logo-dash_img" />
              </Link>
            </div>

            {type !== 'public' && role !== CONFIG.AUTH.ROLES.STANDART && isLoggedIn &&
              <>
                <a href="# " className="header_btn-menu" onClick={onMenuToggle}>
                  {menuShow ?
                      <Icon name="menu-btn-close" />
                    :
                      <Icon name="menu-btn" />
                  }
                </a>
                {menuShow &&
                  <div className="menu-dropdown">
                    <Menu role={role} mobileOnlyShow onClose={() => setMenuShow(false)} />
                  </div>
                }
              </>
            }
          </div>

          {type !== 'public' && role !== CONFIG.AUTH.ROLES.STANDART && isLoggedIn &&
            <div className="header_bottom">
              {role === '' &&
                <div className="mx-auto lg:ml-50 lg:mr-0 lg:order-2" style={{ width: 175 }}>
                  <Button size="md" color="secondary" fullWidth onClick={OpenLightbox}>
                    <Icon name="hours-reserve" className="align-top mr-5" />RESERVA DE HORAS
                  </Button>
                  <Button size="md" color="tertiary" fullWidth className="text-left mt-5" onClick={onAppointmentContactShow}>
                    <Icon name="online-consultation" className="align-top mr-5" />TELEMEDICINA
                  </Button>
                </div>
              }

              <div className="header_options mt-15 lg:mt-0">
                {role !== CONFIG.AUTH.ROLES.ADMIN &&
                  <div className="position-relative mr-20">
                    <HeaderNotify
                      notify={notify}
                      notifyShow={notifyShow}
                      onNotifyChange={onNotifyToggle}
                      onNotifyRead={onNotifyRead}
                    />
                  </div>
                }

                <div className="header_dropdown position-relative lg:order-1">
                  <div className="d-flex align-items-center" onClick={onUserOptionsToggle}>
                    <Icon name="user" />
                    <Text size="14" component="span" inline className="ml-10 mr-20">{userCurrent.getUserFullName()}</Text>
                    <Icon name="arrow-down" />
                  </div>

                  <Dropdown show={optionsShow} className="header_dropdown_options">
                    <ul className="dropdown_options">
                      {role !== CONFIG.AUTH.ROLES.ADMIN &&
                        <li>
                          <Link to={CONFIG.ROUTES.DASHBOARD.PROFILE}>Ver Perfil</Link>
                        </li>
                      }
                      <li onClick={onLogout}>
                        <span>Cerrar sesión</span>
                      </li>
                    </ul>
                  </Dropdown>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <Lightbox />
    </header>
  )
}

export { Header }